import React from 'react';

import { RenderComponentProps } from '../DataTable/types';
import useStyles from './styles';

export const StatusColor: React.FC<RenderComponentProps> = ({ value }) => {
  const classes = useStyles({ value });

  return <span className={classes.status}>{value}</span>;
};
